var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[(_vm.mapReady)?_c('ClientOnly',[_c('yandex-map',{attrs:{"settings":_vm.settings,"coords":_vm.coords,"zoom":"14"},on:{"map-was-initialized":_vm.init}},_vm._l((_vm.currentMarkers),function(m,i){return _c('ymap-marker',{key:m.id,attrs:{"marker-id":0,"icon":_vm.icon,"coords":m.coords}})}),1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }